// export const BaseIp = 'http://192.168.29.102:8083/' //---local path (URL)
export const BaseIp = "https://server3.purnaacademic.in:8443/"   //---Online path (URL)


export const PdfPath = BaseIp + "output/"   //---PDF path 
export const ImgPath = BaseIp + "userImg/"   //---Img path 
export const EmpImgPath = BaseIp + "empImg/"   //---Img path 


export const BaseURL = BaseIp + 'swimpool_ticket/swimmingPool/'
// export const BaseURLPdf = 'http://192.168.29.102:8080/output/'
export const BaseURLPdf = BaseIp + "output/"   //---PDF path 

export const GetUserProfileData = BaseURL + 'user/getUserProfileDataByMobileNo' // Get User Profile Data (GET)

export const SaveUserRegistrationApi = BaseURL + 'user/createUser' // User Reg. Save (POST)

export const SendOtp = BaseURL + 'user/userLogin' // User OTP Send (POST) (params=> ?mobileNo=9545643879)

export const ValidateOtp = BaseURL + 'user/verifyOtp' // User OTP Send (POST) (params=> ?mobileNo=95456438791&otp=090068)

export const AvailableSlots = BaseURL + 'user/getSlotListByGenderAndWeekday' // Available Slots (After Login) (GET) (params=> ?mobileNo=9545643879)

export const GenerateQR = BaseURL + 'payment/initiatePayment' // Generate QR code (After Payment Success) (GET)

export const GetUserQR = BaseURL + 'payment/initiatePayment' // Get QR code (After Payment Success QR getting from response) (GET) (params=> ?mobileNo=9545643879)

export const LastGeneratedQR = BaseURL + 'payment/getLastPaymentQrCodeData' // Last Generated QR code (GET) (params=> ?mobileNo=9545643879)

//http://192.168.29.102:8083/swimpool_ticket/entry/scan?token=xtm73GGtwsamnv_nQuQE8Ouz3Kymaq0BRRk-2lcRqEPMGsjmHDDhVHl2JqakOyzCF4wePZXoKY2lG3uI5omVS800rVyGuX_BWz58s1fvw0XcJUdH04fZN1aOkPuyhX858HrjLkNoThJE2Q3vG0qW7atQcdF0w5twZeE9gm0P5NNSFXyo6w

//( this api for QR CODE scanning...)

//http://192.168.29.102:8083/swimpool_ticket/swimmingPool/entry/scan
export const getQrScannerData = BaseURL + 'entry/scan'
